export const FETCH_FEED_START = 'FETCH_FEED_START';
export const FETCH_FEED_FULFILLED = 'FETCH_FEED_FULFILLED';
export const FETCH_FEED_REJECTED = 'FETCH_FEED_REJECTED';

export const FETCH_FEED_POST_START = 'FETCH_FEED_POST_START';
export const FETCH_FEED_POST_FULFILLED = 'FETCH_FEED_POST_FULFILLED';
export const FETCH_FEED_POST_REJECTED = 'FETCH_FEED_POST_REJECTED';

export const FETCH_MORE_FEED_START = 'FETCH_MORE_FEED_START';
export const FETCH_MORE_FEED_FULFILLED = 'FETCH_MORE_FEED_FULFILLED';
export const FETCH_MORE_FEED_REJECTED = 'FETCH_MORE_FEED_REJECTED';

export const FETCH_USERS_START = 'FETCH_USERS_START';
export const FETCH_USERS_FULFILLED = 'FETCH_USERS_FULFILLED';
export const FETCH_USERS_REJECTED = 'FETCH_USERS_REJECTED';

export const FETCH_FEED_NEXT_PAGE_START = 'FETCH_FEED_NEXT_PAGE_START';
export const FETCH_FEED_NEXT_PAGE_FULFILLED = 'FETCH_FEED_NEXT_PAGE_FULFILLED';

export const FETCH_GROUPS_START = 'FETCH_GROUPS_START';
export const FETCH_GROUPS_FULFILLED = 'FETCH_GROUPS_FULFILLED';
export const FETCH_GROUPS_REJECTED = 'FETCH_GROUPS_REJECTED';

export const UPLOAD_MEDIA_START = 'UPLOAD_MEDIA_START';
export const UPLOAD_MEDIA_FULFILLED = 'UPLOAD_MEDIA_FULFILLED';
export const UPLOAD_MEDIA_REJECTED = 'UPLOAD_MEDIA_REJECTED';

export const SET_ACTIVE_REDUX_MODAL = 'SET_ACTIVE_REDUX_MODAL';

export const SET_SUB_ACTIVE_REDUX_MODAL = 'SET_SUB_ACTIVE_REDUX_MODAL';

export const SET_UPLOAD_MEDIA = 'SET_UPLOAD_MEDIA';
export const SET_UPLOAD_MEDIA_FALSE = 'SET_UPLOAD_MEDIA_FALSE';

export const SET_SELECTED_GROUPS = 'SET_SELECTED_GROUPS';

export const SET_SEARCH_STRING = 'SET_SEARCH_STRING';

export const SET_IS_FEED_SHOWING = 'SET_IS_FEED_SHOWING';

export const SET_FEED_POST_MEDIA_URL = 'SET_FEED_POST_MEDIA_URL';

export const UPLOAD_MEDIA_URL_START = 'UPLOAD_MEDIA_URL_START';
export const UPLOAD_MEDIA_URL_FULFILLED = 'UPLOAD_MEDIA_URL_FULFILLED';
export const UPLOAD_MEDIA_URL_REJECTED = 'UPLOAD_MEDIA_URL_REJECTED';
export const SET_ACTIVE_MEDIA_BAR_OB = 'SET_ACTIVE_MEDIA_BAR_OB';

export const CREATE_FEED_POST_START = 'CREATE_FEED_POST_START';
export const CREATE_FEED_POST_FULFILLED = 'CREATE_FEED_POST_FULFILLED';
export const CREATE_FEED_POST_REJECTED = 'CREATE_FEED_POST_REJECTED';

export const CREATE_FEED_POST_COMMENT_START = 'CREATE_FEED_POST_COMMENT_START';
export const CREATE_FEED_POST_COMMENT_FULFILLED = 'CREATE_FEED_POST_COMMENT_FULFILLED';
export const CREATE_FEED_POST_COMMENT_REJECTED = 'CREATE_FEED_POST_COMMENT_REJECTED';

export const CREATE_FEED_POST_COMMENT_REPLY_START = 'CREATE_FEED_POST_COMMENT_REPLY_START';
export const CREATE_FEED_POST_COMMENT_REPLY_FULFILLED = 'CREATE_FEED_POST_COMMENT_REPLY_FULFILLED';
export const CREATE_FEED_POST_COMMENT_REPLY_REJECTED = 'CREATE_FEED_POST_COMMENT_REPLY_REJECTED';

export const SET_EDIT_MODAL = 'SET_EDIT_MODAL';

export const EDIT_FEED_POST_START = 'EDIT_FEED_POST_START';
export const EDIT_FEED_POST_FULFILLED = 'EDIT_FEED_POST_FULFILLED';
export const EDIT_FEED_POST_REJECTED = 'EDIT_FEED_POST_REJECTED';

export const EDIT_FEED_POST_COMMENT_START = 'EDIT_FEED_POST_COMMENT_START';
export const EDIT_FEED_POST_COMMENT_FULFILLED = 'EDIT_FEED_POST_COMMENT_FULFILLED';
export const EDIT_FEED_POST_COMMENT_REJECTED = 'EDIT_FEED_POST_COMMENT_REJECTED';

export const EDIT_FEED_POST_COMMENT_REPLY_START = 'EDIT_FEED_POST_COMMENT_REPLY_START';
export const EDIT_FEED_POST_COMMENT_REPLY_FULFILLED = 'EDIT_FEED_POST_COMMENT_REPLY_FULFILLED';
export const EDIT_FEED_POST_COMMENT_REPLY_REJECTED = 'EDIT_FEED_POST_COMMENT_REPLY_REJECTED';

export const DELETE_FEED_POST_START = 'DELETE_FEED_POST_START';
export const DELETE_FEED_POST_FULFILLED = 'DELETE_FEED_POST_FULFILLED';
export const DELETE_FEED_POST_REJECTED = 'DELETE_FEED_POST_REJECTED';

export const DELETE_FEED_POST_COMMENT_START = 'DELETE_FEED_POST_COMMENT_START';
export const DELETE_FEED_POST_COMMENT_FULFILLED = 'DELETE_FEED_POST_COMMENT_FULFILLED';
export const DELETE_FEED_POST_COMMENT_REJECTED = 'DELETE_FEED_POST_COMMENT_REJECTED';

export const DELETE_FEED_POST_COMMENT_REPLY_START = 'DELETE_FEED_POST_COMMENT_REPLY_START';
export const DELETE_FEED_POST_COMMENT_REPLY_FULFILLED = 'DELETE_FEED_POST_COMMENT_REPLY_FULFILLED';
export const DELETE_FEED_POST_COMMENT_REPLY_REJECTED = 'DELETE_FEED_POST_COMMENT_REPLY_REJECTED';

export const SET_IS_COMMENT_CLICKED_REDUX = 'SET_IS_COMMENT_CLICKED_REDUX';

export const SET_IS_REPLY_ACTIVATED_REDUX = 'SET_IS_REPLY_ACTIVATED_REDUX';

export const SET_SCROLL_TRUE_FALSE = 'SET_SCROLL_TRUE_FALSE';

export const SET_UNPIN_TOGGLE_FALSE = 'SET_UNPIN_TOGGLE_FALSE';

export const FIST_BUMP_FEED_POST_START = 'FIST_BUMP_FEED_POST_START';
export const FIST_BUMP_FEED_POST_FULFILLED = 'FIST_BUMP_FEED_POST_FULFILLED';
export const FIST_BUMP_FEED_POST_REJECTED = 'FIST_BUMP_FEED_POST_REJECTED';

export const FIST_BUMP_COMMENT_START = 'FIST_BUMP_COMMENT_START';
export const FIST_BUMP_COMMENT_FULFILLED = 'FIST_BUMP_COMMENT_FULFILLED';
export const FIST_BUMP_COMMENT_REJECTED = 'FIST_BUMP_COMMENT_REJECTED';

export const FIST_BUMP_REPLY_START = 'FIST_BUMP_REPLY_START';
export const FIST_BUMP_REPLY_FULFILLED = 'FIST_BUMP_REPLY_FULFILLED';
export const FIST_BUMP_REPLY_REJECTED = 'FIST_BUMP_REPLY_REJECTED';

export const FETCH_PINNED_FEED_START = 'FETCH_PINNED_FEED_START';
export const FETCH_PINNED_FEED_FULFILLED = 'FETCH_PINNED_FEED_FULFILLED';
export const FETCH_PINNED_FEED_REJECTED = 'FETCH_PINNED_FEED_REJECTED';

export const SET_INCOMING_FEED_POST = 'SET_INCOMING_FEED_POST';

export const SET_INCOMING_FEED_POST_COMMENT = 'SET_INCOMING_FEED_POST_COMMENT';

export const SET_INCOMING_FEED_POST_COMMENT_REPLY = 'SET_INCOMING_FEED_POST_COMMENT_REPLY';

export const SET_IS_TYPING = 'SET_IS_TYPING';
export const SET_IS_TYPING_FALSE = 'SET_IS_TYPING_FALSE';

export const FETCH_FEED_COUNT_START = 'FETCH_FEED_COUNT_START';
export const FETCH_FEED_COUNT_FULFILLED = 'FETCH_FEED_COUNT_FULFILLED';
export const FETCH_FEED_COUNT_REJECTED = 'FETCH_FEED_COUNT_REJECTED';

export const SET_IS_TV_MODE = 'SET_IS_TV_MODE';

export const FETCH_EXERCISES_START = 'FETCH_EXERCISES_START';
export const FETCH_EXERCISES_FULFILLED = 'FETCH_EXERCISES_FULFILLED';
export const FETCH_EXERCISES_REJECTED = 'FETCH_EXERCISES_REJECTED';

export const FETCH_TOP_PR_START = 'FETCH_TOP_PR_START';
export const FETCH_TOP_PR_FULFILLED = 'FETCH_TOP_PR_FULFILLED';
export const FETCH_TOP_PR_REJECTED = 'FETCH_TOP_PR_REJECTED';

export const EDIT_TOP_PR_START = 'EDIT_TOP_PR_START';
export const EDIT_TOP_PR_FULFILLED = 'EDIT_TOP_PR_FULFILLED';
export const EDIT_TOP_PR_REJECTED = 'EDIT_TOP_PR_REJECTED';

export const DELETE_TOP_PR_WIDGET = 'DELETE_TOP_PR_WIDGET';
export const RESET_TOP_PR_ERROR = 'RESET_TOP_PR_ERROR';

export const SET_REPORT_POST_INFO = 'SET_REPORT_POST_INFO';
export const SUBMIT_SUPPORT_START = 'SUBMIT_SUPPORT_START';
export const SUBMIT_SUPPORT_FULFILLED = 'SUBMIT_SUPPORT_FULFILLED';
export const SUBMIT_SUPPORT_REJECTED = 'SUBMIT_SUPPORT_REJECTED';
export const RESET_SUPPORT_ERROR = 'RESET_SUPPORT_ERROR';
